import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import {MdTextField} from 'core/components/fields/fields';
import {createForm} from 'core/form/createForm';
import PageAncestor from 'core/common/page/pageAncestor';
import mdEntityService from 'core/metamodel/mdEntityService';
import securityService from 'core/security/securityService';
import {Validate} from 'core/form/validate';
import {AreSame, HasLength} from 'core/form/rules';
import {preSave, FormProps} from 'core/form/formUtils';
import {ErrorComp} from 'core/components/errorComp/errorComp';
import {MODULE, PageProps} from "core/metamodel/metaConstant";
import {User} from "core/security/securityDomain";
import {action} from "mobx";
import uiService from "core/common/service/uiService";
import {observer} from "mobx-react";
import {FIELDDEFSIZE} from "core/form/form";


@observer
export default class SetPassword extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = 'set password';
  static icon = 'unlock-alt';


  static fetchData(routerParams, query) {
    console.log("SetPassword#fetchData()");

    let metadataPromise = mdEntityService.fetchEntities(['User']);

    let username = (routerParams.mode === 'ADMIN') ? routerParams.id : securityService.currentUser.username;

    let userPromise = securityService.readUser(username);


    return Promise.all([metadataPromise, userPromise])
      .then( ([entityMap, userObject]: [any, User]) => {
        securityService.passwordObject = userObject;

      });
  }

  componentWillUnmount() {
    securityService.passwordObject = null;
  }


  @action onSubmit = (evt) => {
    evt.preventDefault();
    console.log('onSubmit ');
    uiService.showToolbarActionFlag();

    let result = preSave(securityService.passwordObject, null, true);
    if (!result) {
      return;
    }

    securityService.resetPassword(securityService.passwordObject, this.context.router.getCurrentParams().mode)
    .then( response => {
      uiService.hideToolbarActionFlag();
      this.goBackOrHome();
    }, (error) => {
      Object.assign(securityService.passwordObject, {oldPassword: undefined, password1: undefined, password2: undefined, $errors: error.response.data.messages});
      securityService.passwordObject.getForm("SetPasswordForm").updateAllFieldsPropValue(securityService.passwordObject);
    });

  };




  render() {


    console.debug('%c setPassword render', 'background-color: yellow');

    return (
      <main className="main-content container">
        <ErrorComp messages={securityService.passwordObject.$errors} />
        <div className="row">
          <div className="col-xs-offset-1 col-xs-10">
            <h4>Change Password</h4></div>
        </div>

        <SetPasswordForm dataObject={securityService.passwordObject} rootObject={securityService.passwordObject} entity={mdEntityService.getEntity('User')}
                         entities={mdEntityService.entityMap} routeParams={this.context.router.getCurrentParams()}
                         onCancel={this.goBackOrHome} onSubmit={this.onSubmit}/>
      </main>
    );
  }

}


interface SetPasswordFormProps extends FormProps<User, User>{
  onSubmit: any;
  onCancel: any;
  routeParams: any;
}



@createForm({
  formName: 'SetPasswordForm',
  fields: [{
    name: 'oldPassword', size: FIELDDEFSIZE.big,
    validators: ['IsRequired']
  }, {
    name: 'password1',size: FIELDDEFSIZE.big,
    validators: ['IsRequired']
  }, {
    name: 'password2', size: FIELDDEFSIZE.big,
    validators: ['IsRequired']
  }
  ]
}, () => <noscript/>)
@observer
class SetPasswordForm extends React.Component<SetPasswordFormProps, undefined> {

  render() {

    let {dataObject, rootObject, entities, routeParams, onSubmit, onCancel, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {oldPassword, password1, password2} = fields;


    return (
      <form onSubmit={onSubmit}>
        { (routeParams.mode === 'USER') ? (
          <div className="row">
            <div className="col-xs-offset-1 col-xs-10">
              <MdTextField type="password" {...oldPassword.props} style={{maxWidth:300}}/>
              <Validate field={oldPassword} value={oldPassword.props.value}/>
            </div>
          </div>
        ): null}
        <div className="row" >
          <div className="col-xs-offset-1 col-xs-10" style={{display: 'flex', flexWrap: 'nowrap'}}>
            <MdTextField type="password" {...password1.props} style={{maxWidth:300}} />
            <Validate field={password1} value={password1.props.value}>
              <HasLength min={8}/>
            </Validate>
            <MdTextField type="password" {...password2.props} style={{maxWidth:300, marginLeft: 20}} />
            <Validate field={password2} value={password2.props.value} needTouch={[['AreSame', 'value1'], ['AreSame', 'value2']]}>
              <HasLength min={8}/>
              <AreSame value1={password1.props.value} value2={password2.props.value} />
            </Validate>
          </div>
        </div>
        <div className="row" style={{marginTop:20}}>
          <div className="col-xs-offset-1 col-xs-10">
            <RaisedButton type="submit"  label="OK" secondary={true} />
            <RaisedButton type="button"  onClick={onCancel} label="Cancel"  style={{marginLeft:20}}/>
          </div>
        </div>
      </form>

    );
  }
}



// WEBPACK FOOTER //
// ./src/core/security/setPassword.tsx